import React, { useState, useEffect, useRef } from 'react';
import { useNotificationContext } from '../../context/NotificationContext';
import { timeAgo } from '../../utils/formatters';

export default function NotificationPanel() {
  const {
    notifications, unreadCount, fetchNotifications, markRead, markAllRead,
  } = useNotificationContext();
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    if (open) {
      fetchNotifications();
    }
  }, [open, fetchNotifications]);

  // Close on outside click
  useEffect(() => {
    function handleClick(e) {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div className="notification-panel-wrapper" ref={panelRef}>
      <button className="notification-bell" onClick={() => setOpen(!open)}>
        <span className="bell-icon">&#128276;</span>
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </button>

      {open && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h4>Notifications</h4>
            {unreadCount > 0 && (
              <button className="btn btn-sm" onClick={markAllRead}>
                Mark all read
              </button>
            )}
          </div>
          <div className="notification-list">
            {notifications.length === 0 ? (
              <p className="empty-state">No notifications</p>
            ) : (
              notifications.map((n) => (
                <div
                  key={n.id}
                  className={`notification-item ${n.is_read ? '' : 'unread'}`}
                  onClick={() => !n.is_read && markRead(n.id)}
                >
                  <p className="notification-message">{n.message}</p>
                  <div className="notification-meta">
                    {n.listing_url && (
                      <a
                        href={n.listing_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        View listing
                      </a>
                    )}
                    <span className="notification-time">{timeAgo(n.created_at)}</span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
